import { Button, Card, CardContent } from "@devhop/ui";
import { useNavigate, useParams } from "@tanstack/react-router";
import { config } from "@/shared/lib/config";

export function PublicFormSuccessPage() {
  const { formId } = useParams({ from: "/f/$formId/success" });
  const navigate = useNavigate();

  return (
    <main className="mx-auto flex w-full max-w-xl flex-col gap-8 px-4 py-8 pb-16">
      <Card>
        <CardContent className="space-y-4 pt-6">
          <h1 className="font-semibold text-xl tracking-tight">
            ໄດ້ຮັບຄຳຕອບຂອງທ່ານແລ້ວ
          </h1>
          <p className="text-muted-foreground text-sm leading-relaxed">
            ລະບົບບັນທຶກການສົ່ງຟອມສຳເລັດແລ້ວ ການຕອບກັບຈາກທີມງານມີຫຼືບໍ່ນັ້ນຂຶ້ນກັບນະໂຍບາຍຂອງແຕ່ລະຟອມ
          </p>
          <Button
            type="button"
            variant="outline"
            onClick={() => {
              void navigate({
                to: "/f/$formId",
                params: { formId },
              });
            }}
          >
            ກັບໄປໜ້າຟອມ
          </Button>
          <p className="text-muted-foreground text-xs">{config.brandName}</p>
        </CardContent>
      </Card>
    </main>
  );
}
